import TemplateIssueRootCauseSelectDropdown from './TemplateIssueRootCauseSelectDropdown';
import {connect} from '../../app/connect';
import {
  getActiveIssueRootCausesGroupedDropdownOptions,
  getActiveIssueRootCausesGroupedDropdownOptionsIncludingCurrent,
  getIssueRootCausesDefinitionsEntitiesMap
} from '../../app/selectors';

const getIssueRootCauseSelectDropdownValues = (selectedOption, state) => {
  if (selectedOption && !selectedOption.isActive) {
    return getActiveIssueRootCausesGroupedDropdownOptionsIncludingCurrent(state, selectedOption.id);
  }
  return getActiveIssueRootCausesGroupedDropdownOptions(state);
};

const mapStateToProps = (state, ownProps) => {
  const issueRootCausesDefinitionsEntitiesMap = getIssueRootCausesDefinitionsEntitiesMap(state);
  const selectedOption = issueRootCausesDefinitionsEntitiesMap[ownProps.selectedOptionId];
  return {
    selectedOption,
    activeIssueRootCausesGroupedDropdownOptions: getIssueRootCauseSelectDropdownValues(selectedOption, state)
  };
};

export default connect(mapStateToProps)(TemplateIssueRootCauseSelectDropdown);
